import { combineReducers } from 'redux';
import homeReducer from '../pages/Layout/reducer';

export default combineReducers({homeReducer});
